import { render, staticRenderFns } from "./AtomFormInputWrapper.vue?vue&type=template&id=4d827e22&scoped=true&"
import script from "./AtomFormInputWrapper.vue?vue&type=script&lang=js&"
export * from "./AtomFormInputWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AtomFormInputWrapper.vue?vue&type=style&index=0&id=4d827e22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d827e22",
  null
  
)

export default component.exports